"use strict";
/* Copyright (c) 2022, VRAI Labs and/or its affiliates. All rights reserved.
 *
 * This software is licensed under the Apache License, Version 2.0 (the
 * "License") as published by the Apache Software Foundation.
 *
 * You may not use this file except in compliance with the License. You may
 * obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied. See the
 * License for the specific language governing permissions and limitations
 * under the License.
 */
var __assign =
    (this && this.__assign) ||
    function () {
        __assign =
            Object.assign ||
            function (t) {
                for (var s, i = 1, n = arguments.length; i < n; i++) {
                    s = arguments[i];
                    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                }
                return t;
            };
        return __assign.apply(this, arguments);
    };
var __awaiter =
    (this && this.__awaiter) ||
    function (thisArg, _arguments, P, generator) {
        function adopt(value) {
            return value instanceof P
                ? value
                : new P(function (resolve) {
                      resolve(value);
                  });
        }
        return new (P || (P = Promise))(function (resolve, reject) {
            function fulfilled(value) {
                try {
                    step(generator.next(value));
                } catch (e) {
                    reject(e);
                }
            }
            function rejected(value) {
                try {
                    step(generator["throw"](value));
                } catch (e) {
                    reject(e);
                }
            }
            function step(result) {
                result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
            }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    };
var __generator =
    (this && this.__generator) ||
    function (thisArg, body) {
        var _ = {
                label: 0,
                sent: function () {
                    if (t[0] & 1) throw t[1];
                    return t[1];
                },
                trys: [],
                ops: [],
            },
            f,
            y,
            t,
            g;
        return (
            (g = { next: verb(0), throw: verb(1), return: verb(2) }),
            typeof Symbol === "function" &&
                (g[Symbol.iterator] = function () {
                    return this;
                }),
            g
        );
        function verb(n) {
            return function (v) {
                return step([n, v]);
            };
        }
        function step(op) {
            if (f) throw new TypeError("Generator is already executing.");
            while (_)
                try {
                    if (
                        ((f = 1),
                        y &&
                            (t =
                                op[0] & 2
                                    ? y["return"]
                                    : op[0]
                                    ? y["throw"] || ((t = y["return"]) && t.call(y), 0)
                                    : y.next) &&
                            !(t = t.call(y, op[1])).done)
                    )
                        return t;
                    if (((y = 0), t)) op = [op[0] & 2, t.value];
                    switch (op[0]) {
                        case 0:
                        case 1:
                            t = op;
                            break;
                        case 4:
                            _.label++;
                            return { value: op[1], done: false };
                        case 5:
                            _.label++;
                            y = op[1];
                            op = [0];
                            continue;
                        case 7:
                            op = _.ops.pop();
                            _.trys.pop();
                            continue;
                        default:
                            if (
                                !((t = _.trys), (t = t.length > 0 && t[t.length - 1])) &&
                                (op[0] === 6 || op[0] === 2)
                            ) {
                                _ = 0;
                                continue;
                            }
                            if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) {
                                _.label = op[1];
                                break;
                            }
                            if (op[0] === 6 && _.label < t[1]) {
                                _.label = t[1];
                                t = op;
                                break;
                            }
                            if (t && _.label < t[2]) {
                                _.label = t[2];
                                _.ops.push(op);
                                break;
                            }
                            if (t[2]) _.ops.pop();
                            _.trys.pop();
                            continue;
                    }
                    op = body.call(thisArg, _);
                } catch (e) {
                    op = [6, e];
                    y = 0;
                } finally {
                    f = t = 0;
                }
            if (op[0] & 5) throw op[1];
            return { value: op[0] ? op[1] : void 0, done: true };
        }
    };
Object.defineProperty(exports, "__esModule", { value: true });
exports.consumeCode = exports.resendCode = exports.createCode = exports.normaliseUserInput = void 0;
var utils_1 = require("../../utils");
var utils_2 = require("../authRecipe/utils");
function normaliseUserInput(config) {
    var override = __assign(
        {
            functions: function (originalImplementation) {
                return originalImplementation;
            },
        },
        config.override
    );
    return __assign(__assign({}, (0, utils_2.normaliseAuthRecipe)(config)), { override: override });
}
exports.normaliseUserInput = normaliseUserInput;
/**
 * These functions are helper functions so that the logic can be exposed from both
 * passwordless and thirdpartypasswordless recipes without having to duplicate code
 */
function createCode(input) {
    return __awaiter(this, void 0, void 0, function () {
        var normalisedUserContext, createCodeResponse;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    normalisedUserContext = (0, utils_1.getNormalisedUserContext)(input.userContext);
                    return [
                        4 /*yield*/,
                        input.recipeImplementation.createCode(
                            __assign(__assign({}, input), { userContext: normalisedUserContext })
                        ),
                    ];
                case 1:
                    createCodeResponse = _a.sent();
                    return [
                        4 /*yield*/,
                        input.recipeImplementation.setLoginAttemptInfo({
                            attemptInfo: {
                                deviceId: createCodeResponse.deviceId,
                                preAuthSessionId: createCodeResponse.preAuthSessionId,
                                flowType: createCodeResponse.flowType,
                            },
                            userContext: normalisedUserContext,
                        }),
                    ];
                case 2:
                    _a.sent();
                    return [2 /*return*/, createCodeResponse];
            }
        });
    });
}
exports.createCode = createCode;
function resendCode(input) {
    return __awaiter(this, void 0, void 0, function () {
        var normalisedUserContext, previousAttemptInfo;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    normalisedUserContext = (0, utils_1.getNormalisedUserContext)(input.userContext);
                    return [
                        4 /*yield*/,
                        input.recipeImplementation.getLoginAttemptInfo({
                            userContext: normalisedUserContext,
                        }),
                    ];
                case 1:
                    previousAttemptInfo = _a.sent();
                    /**
                     * If previousAttemptInfo is undefined then local storage was probably cleared by another tab.
                     * In this case we use empty strings when calling the API because we want to
                     * return "RESTART_FLOW_ERROR"
                     */
                    return [
                        2 /*return*/,
                        input.recipeImplementation.resendCode(
                            __assign(__assign({}, input), {
                                userContext: normalisedUserContext,
                                deviceId: previousAttemptInfo === undefined ? "" : previousAttemptInfo.deviceId,
                                preAuthSessionId:
                                    previousAttemptInfo === undefined ? "" : previousAttemptInfo.preAuthSessionId,
                            })
                        ),
                    ];
            }
        });
    });
}
exports.resendCode = resendCode;
function consumeCode(input) {
    return __awaiter(this, void 0, void 0, function () {
        var normalisedUserContext, additionalParams, attemptInfoFromStorage, linkCode, preAuthSessionId;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    normalisedUserContext = (0, utils_1.getNormalisedUserContext)(input.userContext);
                    if (!("userInputCode" in input)) return [3 /*break*/, 2];
                    return [
                        4 /*yield*/,
                        input.recipeImplementation.getLoginAttemptInfo({
                            userContext: normalisedUserContext,
                        }),
                    ];
                case 1:
                    attemptInfoFromStorage = _a.sent();
                    /**
                     * If attemptInfoFromStorage is undefined then local storage was probably cleared by another tab.
                     * In this case we use empty strings when calling the API because we want to
                     * return "RESTART_FLOW_ERROR"
                     *
                     * Note: We dont do this for the linkCode flow because that does not depend on local storage.
                     */
                    additionalParams = {
                        userInputCode: input.userInputCode,
                        deviceId: attemptInfoFromStorage === undefined ? "" : attemptInfoFromStorage.deviceId,
                        preAuthSessionId:
                            attemptInfoFromStorage === undefined ? "" : attemptInfoFromStorage.preAuthSessionId,
                    };
                    return [3 /*break*/, 3];
                case 2:
                    linkCode = input.recipeImplementation.getLinkCodeFromURL({
                        userContext: input.userContext,
                    });
                    preAuthSessionId = input.recipeImplementation.getPreAuthSessionIdFromURL({
                        userContext: input.userContext,
                    });
                    additionalParams = {
                        linkCode: linkCode,
                        preAuthSessionId: preAuthSessionId,
                    };
                    _a.label = 3;
                case 3:
                    return [
                        2 /*return*/,
                        input.recipeImplementation.consumeCode(
                            __assign({ userContext: normalisedUserContext, options: input.options }, additionalParams)
                        ),
                    ];
            }
        });
    });
}
exports.consumeCode = consumeCode;
